import Analytics from "analytics";
import { cacheHelper } from "./cache";

const addEvent = async (event, productId) => {
  event.product_id = productId;
  const eventString = JSON.stringify(event);
  await cacheHelper.addEvent(eventString);
};

export const initAnalytics = (projectRef, url, productId) => {
  const event = {
    name: `${projectRef}-EventActions`,
    page: ({
      payload
    }) => {
      addEvent(payload, url, productId);
    },
    track: ({
      payload
    }) => {
      addEvent(payload, productId);
    }
  };
  const analytics = Analytics({
    app: projectRef,
    plugins: [event]
  });
  return analytics;
};